module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot01_stay-e5522801ba6885d0e3b27b8b779010f5.jpg";